import api from '@pray/shared/utils/api';

type Params = {
  artistId: string;
};

export async function generateMonthlyPerformanceReport({ artistId }: Params) {
  const url = `/web/studio/artists/${artistId}/analytics/revenue/reports/monthly-performance`;
  const response = await api.executePostRequest<{ data: unknown }>(url, {});
  return response.data.data;
}
